/**
 * API Module
 */
//Core
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//Services
import { ApiService } from "../service/api/api.service";
import { ApiUrlService } from "../service/apiurl/apiurl.service";
import { ErrorCatcherService } from "../service/errorCatcher/errorCatcher.service";

@NgModule({
    imports: [
      CommonModule
    ],
    declarations: [
    ],
    bootstrap: [
    ],
    providers: [
      ApiService,
      ApiUrlService,
      ErrorCatcherService,
    ]
})
export class ApiModule { }
